import React, { Component } from 'react';
import classNames from 'classnames';

class InputField extends Component {
  render() {
    const {input, type, disabled, autocomplete, handleChange, meta: { touched, error }, placeholder, label, style, inputProps } = this.props;
    return (
      <div style={style} className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
        <input 
          {...input} 
          type={type}
          className="create-dialog-form__control"
          placeholder={placeholder}
          autocomplete={autocomplete}
          maxLength={253}
          onChange={(e) => {
            if(handleChange){
              handleChange(e, input);
              return;
            }
            input.onChange(e);
          }}
          disabled={disabled}
          {...inputProps}
        />
        
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
      </div>
    );
  }
}

export default InputField;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/helpers/Fields/InputField.jsx